<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 100px)">
    <el-table-column label="序号" type="index" width="100">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="CurrDeposit" label="静态权益">
    </el-table-column>
    <el-table-column prop="PositionProfit" label="浮动盈亏">
    </el-table-column>
    <el-table-column prop="CurrBalance" label="今权益">
    </el-table-column>
    <el-table-column prop="CurrUse" label="今可用">
    </el-table-column>
    <el-table-column prop="CurrMargin" label="保证金">
    </el-table-column>
    <el-table-column prop="FrozenMoney" label="冻结资金">
    </el-table-column>
    <el-table-column prop="RiskRatio" label="风险度">
    </el-table-column>
    <el-table-column prop="CreateDate" label="开户日期" width="180" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="OpenPositionPower" label="开仓权限">
      <template slot-scope="scope">
        <span>{{scope.row.OpenPositionPower == true ? "允许" : "禁止"}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="OnLineState" label="在线状态" width="90">
      <template slot-scope="scope">
        <i v-if="scope.row.OnLineState" class="el-icon-success OnlineStatess"></i>
        <i v-if="!scope.row.OnLineState" class="el-icon-error noOnLineState"></i>
      </template>
    </el-table-column>
    <!-- 查看明细弹窗 -->
  </el-table>
</template>

<script>
import EnumConfig from "../../../assets/js/EnumConfig.js";
export default {
  // 委托表格
  name: "delegationDetailT",
  data() {
    return {
      dialogVisible: false,
      obj: {}
    };
  },
  props: ["data"],
  filters: {
    GetDelegateOrderStateType(type) {
      return EnumConfig.GetDelegateOrderStateType(type);
    },
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    },
    PositionEffect(type) {
      return EnumConfig.PositionEffect(type);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.obj = row;
    }
  }
};
</script>

<style scoped>
.noOnLineState {
  color: #fd563c;
}
.OnlineStatess {
  color: #08d969 !important;
}
</style>
 


// WEBPACK FOOTER //
// src/components/selects/mycapital/mycapitalT.vue